import React, { useEffect } from 'react';
import { useCart } from '../context/CartContext';

const Product = ({ product }) => {

  const { state, dispatch } = useCart();

  // Buscar el producto en el carrito para obtener su cantidad actual
  const productInCart = state.carrito.find((item) => item.id === product.id);
  const quantityInCart = productInCart ? productInCart.quantity : 0;

  // Función para incrementar la cantidad en el carrito
  const incrementar = () => {
    dispatch({
      type: 'ADD_TO_CART',
      payload: { ...product }, // Enviamos el producto al carrito
    });

  };

  // Función para decrementar la cantidad en el carrito
  const decrementar = () => {
    if (quantityInCart > 0) {
      dispatch({
        type: 'SUBTRACT_TO_CART',
        payload: { ...product }, // Enviamos el producto al carrito
      });
    }    
  };
  if (!product.disponible) {
    return null;
    }
  return (
    <div className="product shadow text-center">
      {/* Imagen del producto */}
      <div className="product-image" style={{ backgroundImage: `url(${product.img})` }}>
        
      </div>
      {/* Detalles del producto */}
      <div className="product-details">
        <div className="product-title">{product.nombre}</div>
        <div className="product-price">${product.precio} x {product.presentacion}</div>
      </div>
      {/* Controles del producto */}
      <div className="productControl">
        {/* Botón para decrementar */}
        <button className="decrementar" onClick={decrementar} disabled={quantityInCart === 0}>
          -
        </button>
        {/* Contador */}
        <span className="count">{quantityInCart}</span>
        {/* Botón para incrementar */}
        <button className="incrementar" onClick={incrementar}>
          +
        </button>
      </div>
    </div>
  );
};

export default Product;